import Device from 'utils/device'

const template = {
    Home: {
        PC: () => import('views/Home'),
        MP: () => import('views/HomeMobile')
    },
    About: {
        PC: () => import('views/About'),
        MP: () => import('views/AboutMobile')
    },
    Department: {
        PC: () => import('views/Department'),
        MP: () => import('views/DepartmentMobile')
    },
    DepartmentInfo: {
        PC: () => import('views/DepartmentInfo'),
        MP: () => import('views/DepartmentInfoMobile')
    },
    Blog: {
        PC: () => import('views/Blog'),
        MP: () => import('views/BlogMobile')
    },
    BlogDetail: {
        PC: () => import('views/BlogDetail'),
        MP: () => import('views/BlogDetailMobile'),
    },
    Zone: {
        PC: () => import('views/Zone'),
        MP: () => import('views/ZoneMobile')
    },
    ZoneDetail: {
        PC: () => import('views/ZoneDetail'),
        MP: () => import('views/ZoneDetailMobile')
    },
    Career: {
        PC: () => import('views/Career'),
        MP: () => import('views/CareerMobile')
    },
    NotFound: () => import('views/NotFound')
}

export default (name) => {
    if (name == 'NotFound' || !template[name]) return template['NotFound']
    return template[name][Device.isMobile ? "MP" : 'PC']
}
